import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { User } from 'src/models/user.model';

@Component({
  selector: 'app-user-sales-readings',
  templateUrl: './sales-readings.component.html',
  styleUrls: ['./sales-readings.component.css']
})
export class UserSalesReadingsComponent implements OnInit {
  private userAuth: User;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authService.user$.subscribe(user => {
      this.userAuth = user;
      if (!this.authService.isSuperAdmin(this.userAuth)) {
        const account = JSON.parse(localStorage.getItem('account'));
        if (account?.account_key) {
          this.router.navigate(['/', account.account_key, 'user', 'dashboard']);
        } else {
          this.router.navigate(['/']);
        }
      }
    });
  }
} 